import { countriesCode } from '@share/constants';

export const DEFAULT_MAX_LENGTH = 12;

export const PHONE_COUNTRY_OPTIONS = countriesCode.map((code) => ({
  value: code.dialCode,
  label: `${code.isoCode} ${code.dialCode}`,
}));
